import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLangugeDetected } from "../store/reducers/dashboardSlice";

const GoogleTranslate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Google Translate initialization function
    const googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en" },
          "google_translate_element"
        );
      }
    };

    // Load Google Translate script only if not already loaded
    if (!document.querySelector("#google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.defer = true;

      // Append the script to <head> for better loading behavior
      document.head.appendChild(script);

      // Attach the init function to the window object
      window.googleTranslateElementInit = googleTranslateElementInit;
    } else {
      // If the script already exists, initialize Google Translate directly
      googleTranslateElementInit();
    }

    // MutationObserver to detect style changes (detecting language dropdown)
    const targetNode = document.body;
    const config = { attributes: true, attributeFilter: ["style"] };

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes" && mutation.attributeName === "style") {
          const newTopValue = targetNode.style.top;
          dispatch(setLangugeDetected(newTopValue !== "0px"));
        }
      }
    });

    observer.observe(targetNode, config);

    // Cleanup: disconnect observer on component unmount
    return () => observer.disconnect();
  }, [dispatch]);

  return (
    <div>
      <div id="google_translate_element"></div>
      <style>{`
        .goog-te-combo {
          padding: 2px;
        }
      `}</style>
    </div>
  );
};

export default GoogleTranslate;
